import React, { Component } from "react";
import { connect } from "react-redux";
import moment from 'moment';
import { Table, Card, Tag, Button, Tooltip, Modal, DatePicker } from "antd";
import { req_list_pim_backfill_log_self } from "../../api";
import { getDateYYYYMM, formateHHMMDate } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import BackfillSetupOpenModal from "./backfill-setup-open-modal";

class BackfillLogStaff extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: window.innerWidth,
    nowYearMonth: getDateYYYYMM(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    item: {},
    isAddModal: false,
    isSetupModal: false,
  };

  UNSAFE_componentWillMount() {
    window.removeEventListener("resize", this.resize.bind(this));
    this.init_columns();
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_item_list();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { nowYearMonth, searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data: [] });
    const result = await req_list_pim_backfill_log_self(
      userLevel,
      userCode,
      nowYearMonth,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      //console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  // 樣式設定 //////////////////////////////////////////////
  statusApplyDescription = (Status) => {
    switch (Status) {
      case "APPLY":
        return "申請中";
      case "AY":
        return "單位二級主管通過";
      case "BY":
        return "單位一級主管通過";
      case "CY":
        return "人事室承辦人通過";
      case "DY":
        return "人事室承辦主管通過";
      case "EY":
        return "人事室主任通過";
      case "ALLAGREE":
        return "申請已通過";
      case "AN":
        return "單位二級主管未通過";
      case "BN":
        return "單位一級主管未通過";
      case "CN":
        return "人事室承辦人未通過";
      case "DN":
        return "人事室承辦主管未通過";
      case "EN":
        return "人事室主任未通過";
      case "ZN":
        return "註銷";
      default:
        return "申請未通過";
    }
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "REASON":
        switch (param) {
          case "工作日":
            return "blue";
          case "休息日":
            return "green";
          case "例假日":
          case "國定假日":
          case "停班停課":
          case "休息日加班":
            return "red";
          case "休假日":
            return "gold";
          case "平假日調換":
            return "purple";
          case "工作日調移":
            return "Tan";
          case "工作日加班":
            return "orange";
          default:
            return "default";
        }
      case "TYPE_APPLY":
        switch (param) {
          case "補簽到退申請":
            return "blue";
          case "工作日加班申請":
            return "orange";
          case "休息日加班申請":
            return "red";
          case "平假日調換申請":
            return "purple";
          case "工作日調移申請":
            return "Tan";
          default:
            return "default";
        }
      case "WEEK":
        switch (param) {
          case "週一":
          case "週二":
          case "週三":
          case "週四":
          case "週五":
            return "blue";
          case "週六":
            return "green";
          case "週日":
            return "red";
          default:
            return "default";
        }
      case "STATUS_WORK":
        switch (param) {
          case "PASS":
            return "red";
          case "WORK":
            return "blue";
          default:
            return "blue";
        }
      case "STATUS_APPLY":
        switch (param) {
          case "APPLY":
            return "blue";
          case "AY":
            return "blue";
          case "BY":
            return "blue";
          case "CY":
            return "blue";
          case "DY":
            return "blue";
          case "EY":
            return "blue";
          case "ALLAGREE":
            return "green";
          case "AN":
            return "red";
          case "BN":
            return "red";
          case "CN":
            return "red";
          case "DN":
            return "red";
          case "EN":
            return "red";
          case "ZN":
            return "red";
          default:
            return "blue";
        }
      case "STATUS_CONFIRM":
        switch (param) {
          case "NO":
            return "red";
          case "YES":
            return "green";
          default:
            return "default";
        }
      default:
        return "blue";
    }
  }

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_item_list();
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "申請分類",
        dataIndex: "BunchReason",
        key: "BunchReason",
        align: "center",
        width: 100,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("TYPE_APPLY", text)}>
              {text}
            </Tag>
          </>
        ),
      },
      {
        title: "審查狀況",
        dataIndex: "BackFillStatus",
        key: "BackFillStatus",
        align: "center",
        width: 100,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("STATUS_APPLY", text)}>
              {this.statusApplyDescription(text)}
            </Tag>
          </>
        ),
      },
      {
        title: "職號",
        dataIndex: "StaffCode",
        key: "StaffName",
        align: "center",
        width: 80,
        render: (text) => <>{text}</>,
      },
      {
        title: "姓名",
        dataIndex: "StaffName",
        key: "StaffName",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "補簽日期",
        dataIndex: "BunchDate",
        key: "BunchDate",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "補簽時間",
        dataIndex: "BunchTime",
        key: "BunchTime",
        align: "center",
        width: 100,
        render: (text) => <>{formateHHMMDate(text)}</>,
      },
      {
        title: "申請說明",
        width: 100,
        render: (item) => (
          <>
            {item.RecordDescription}
          </>
        ),
      },
    ];
  };

  onYearMonthChange = (date, dateString) => {
    this.setState({ nowYearMonth: dateString });
    //console.log(date, dateString);
  };

  ///////////////////////////////////////////////////////////
  render() {
    const { data, loading, nowYearMonth, isSetupModal } = this.state;
    const title = (
      <div>
        {/* <Input
          placeholder="年月"
          style={{ width: 100, margin: "0 5px" }}
          value={nowYearMonth}
          onChange={(event) =>
            this.setState({ nowYearMonth: event.target.value })
          }
        /> */}
        <DatePicker defaultValue={moment(nowYearMonth)} onChange={this.onYearMonthChange} picker="month" format="YYYYMM"/>
        <Button type="primary" onClick={() => this.api_item_list()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_refresh()}>
          <i className="fas fa-sync-alt"></i>
        </Button>{" "}
        <Tooltip placement="top" title="職工超過三日以上的打卡補登設定">
          <Button
            type="primary"
            onClick={() => this.setState({ isSetupModal: true })}
            danger
          >
           <i className="fas fa-cog" ></i>
            <span style={{ marginLeft: "4px" }}>開放職工補登設定</span>
          </Button>
        </Tooltip>{" "}
      </div>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          rowKey="Uid"
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <Modal
          destroyOnClose={true}
          visible={isSetupModal}
          width={450}
          onOk={() => {
            this.setState({ isSetupModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isSetupModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <BackfillSetupOpenModal />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(BackfillLogStaff);
